import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";

export default function ConfirmDialog({
  isClient,
  message,
  confirmLabel = "Confirm",
  isDanger = false,
  onConfirm,
  onCancel,
}) {
  if (!isClient || !message) {
    return null;
  }
  return createPortal(
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 px-4"
      onClick={onCancel}
    >
      <div
        className="panel-strong w-full max-w-sm p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-sm text-slate-700 dark:text-slate-200">{message}</p>
        <div className="mt-5 flex justify-end gap-3">
          <Button type="button" className="btn-secondary" onClick={onCancel}>
            Go back
          </Button>
          <Button
            type="button"
            className={isDanger ? "btn-danger" : "btn-primary"}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
